module.exports = __webpack_public_path__ + "images/help/video-newtodo-small@2x-cd6e22eb9a14a391835c6975cf26188d.png";